import React from 'react'

import PageTransition from './templateParts/PageTransition'

export default function Posts() {
  return (
    <PageTransition>
      <div>Posts</div>
    </PageTransition>
  )
}
